<div class="favie-search-bar web-admin">
  <form (ngSubmit)="search()">
    <mat-form-field [floatLabel]="'never'" appearance="fill">
      <input matInput type="text" [formControl]="searchControl" [placeholder]="placeholder" />
      <mat-icon *ngIf="!imageSrc" matSuffix>search</mat-icon>
      <img [src]="imageSrc" *ngIf="imageSrc" (click)="search()" matSuffix>
    </mat-form-field>
  </form>
</div>